import { render, staticRenderFns } from "./ElementConfigurableScaleTableColumn.vue?vue&type=template&id=62c30d5c&scoped=true"
import script from "./ElementConfigurableScaleTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementConfigurableScaleTableColumn.vue?vue&type=script&lang=js"
import style0 from "./ElementConfigurableScaleTableColumn.vue?vue&type=style&index=0&id=62c30d5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c30d5c",
  null
  
)

export default component.exports